import { Injectable } from "@angular/core";

import { firstValueFrom, Observable, ReplaySubject } from "rxjs";

import { Task, TaskTrack } from "../models/task.interface";


@Injectable()
export class SequentialTaskHandlerService {

    private queue: TaskTrack<any>[] = [];
    private processing: boolean = false;

    public handleTask<T>(task: Task<T>): Promise<T> {
        return firstValueFrom(this.enqueueTask<T>(task));
    }

    private enqueueTask<T>(task: Task<T>): Observable<T> {
        const emitter: ReplaySubject<T> = new ReplaySubject<T>(1);

        // Add the task to the queue (never discard tasks)
        this.queue.push({ task, emitter });

        // If there are no tasks processing, start processing this one.
        if (!this.processing) this.processNextTask().then();

        return emitter.asObservable();
    }

    private async processNextTask(): Promise<void> {
        if (!this.queue.length) return;

        this.processing = true;

        // Get the first task from the queue.
        const { task, emitter } = this.queue.shift()!;

        try {
            // Execute the task
            const result: any = await task();

            // Emit the result and close the emitter
            emitter.next(result);
            emitter.complete();

        } catch (error) {
            // Emit the error and close the emitter.
            emitter.error(error);
        }

        if (this.queue.length > 0) {
            // Process the next task in the queue if there is one.
            this.processNextTask().then();
        } else {
            // Otherwise, finish the processing.
            this.processing = false;
        }
    }
}

